import { OrderState } from "../../pages/OrderDetailsPage/OrderDetailsTypes";
import { DeliveryStatusUIConfig } from "./deliveryStatus.types";

export const DELIVERY_STATUS_UI: Record<OrderState, DeliveryStatusUIConfig> = {
  [OrderState.OPEN]: {
    label: "account.assembling",
    textColor: "#7CB342",
    backgroundColor: "#FFFFFF",
    borderColor: "#7CB342",
  },

  [OrderState.SHIPPING]: {
    label: "account.onTheWay",
    textColor: "#7CB342",
    backgroundColor: "#FFFFFF",
    borderColor: "#7CB342",
  },

  [OrderState.COMPLETED]: {
    label: "account.delivered",
    textColor: "#FFFFFF",
    backgroundColor: "#7CB342",
  },

  [OrderState.CANCELLED]: {
    label: "account.cancelled",
    textColor: "#FFFFFF",
    backgroundColor: "#111827",
  },
};
